const LoaderContainer = ({ children }) => {
  return <div className="loader_container">{children}</div>;
};
export default LoaderContainer;
